import React from 'react';
import {HeroUIProvider, ToastProvider} from "@heroui/react";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {UserProvider} from "./UserInfo";
import {ToastGuard} from "../components/ToastGuard";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
});

const Providers = ({children}) => {
    return (
        <HeroUIProvider>
            <ToastProvider
                placement="top-center"
                disableAnimation
                maxVisibleToasts={2}
                toastOffset={12}
                toastProps={{
                    dir: 'rtl',
                    timeout: 4000,
                    shouldShowTimeoutProgress: true,
                    variant: 'bordered',
                    radius: 'lg',
                }}
                regionProps={{
                    classNames: {
                        base: 'rest-toast-region',
                    },
                }}
            />
            <ToastGuard />
            <QueryClientProvider client={queryClient}>
                <UserProvider>
                    {children}
                </UserProvider>
            </QueryClientProvider>
        </HeroUIProvider>
    );
};

export default Providers;
